<user-navigation></user-navigation>

<div class="container-fluid manager-bg">
  <div class="row mt-5">
    <div class="col-md-12 col-lg-10 mt-5 mx-auto">
      <div id="page-redirection">
        <a routerLink="/user/profile" class="text-white">
            <img src="../../../../assets/images/arrows/arrow-left-white.png">
            Back to Account
        </a>
      </div>
      <h3 class="display-4 box-title text-white mb-3 mb-md-0">{{ orgDetails.organisation.name }} Dashboard</h3>

      <div class="row my-0 my-md-5">
        <div class="col-md-8 col-lg-7 col-xl-5">
          <div class="row">
            <div class="col-md-6 col-lg-6 mb-4">
              <span class="text-white">Admin Users</span>
              <div class="card mt-1 b-radius-125 p-3 p-md-0" *ngIf="orgDetails.admins?.length">
                <div class="card-body">
                  <p *ngFor="let user of orgDetails.admins">
                    <img class="rounded-circle user-avatar mr-1" *ngIf="user.avatar" [src]="user.avatar" >
                    <img class="rounded-circle user-avatar mr-1" *ngIf="!user.avatar" src="../../../../assets/images/avatars/default_profile.png">
                    {{ user.first_name }}
                    {{ user.last_name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-6 mb-4">
              <span class="text-white">Voucher Codes</span>
              <div class="card mt-1 b-radius-125 p-3 p-md-0" *ngIf="orgDetails.vouchers?.length">
                <div class="card-body">
                  <p class="m-2" *ngFor="let voucher of orgDetails.vouchers">
                    {{ voucher.code }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-5 col-xl-7">
        </div>
      </div>

      <div class="my-0 my-md-5 teal">
        <span class="text-white mt-5">Summary Reports</span>
        <div class="row my-2">
          <div class="col-md-3">
            <div class="card mt-1 b-radius-125 p-3 p-md-0">
              <div class="card-body">
                <div class="fs-9em tablet-title">Users</div>
                <h4 class="mt-1 card-text font-weight-bold">
                  <div *ngIf="orgDetails.total_users_percentage == 0">{{ orgDetails.total_users }}</div>
                  <div *ngIf="orgDetails.total_users_percentage > 0">{{ orgDetails.total_users_percentage }}%</div>
                </h4>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card mt-1 b-radius-125 p-3 p-md-0">
              <div class="card-body">
                <div class="fs-9em tablet-title">Points</div>
                <h4 class="mt-1 card-text font-weight-bold">
                  {{ orgDetails.organisation.points }}
                </h4>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card mt-1 b-radius-125 p-3 p-md-0">
              <div class="card-body">
                <div class="fs-9em tablet-title">Trainer Users</div>
                <h4 class="mt-1 card-text font-weight-bold">
                  {{ orgDetails.trainer_users_percentage }}%
                </h4>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card mt-1 b-radius-125 p-3 p-md-0">
              <div class="card-body">
                <div class="fs-9em tablet-title">7 Day Challenge Users</div>
                <h4 class="mt-1 card-text font-weight-bold">
                  {{ orgDetails.challenge_user_7_day.users_completed_percentage }}%
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <span class="text-white mt-5">7-Day Challenge Results</span>
        <div class="my-2">
          <div class="row">
            <div class="col-md-4 d-md-flex">
              <div class="form-group col-md-6 px-0 mr-md-3">
                <div class="input-group">
                  <input
                    class="form-control b-radius-left"
                    placeholder="Date from"
                    name="fromDate"
                    ngbDatepicker
                    (click)="d.toggle()"
                    (dateSelect)="onDateFromSelection($event)"
                    #d="ngbDatepicker"
                    id="dateInputFrom"
                    [(ngModel)]="dpFromDate"
                    readonly
                  >
                  <div class="input-group-append clear-date">
                    <span class="input-group-text b-radius-right" (click)="clearDateFrom()"><i class="fa fa-times"></i> </span>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6 px-0">
                <div class="input-group">
                  <input
                    class="form-control b-radius-left"
                    placeholder="Date to"
                    name="toDate"
                    ngbDatepicker
                    (click)="f.toggle()"
                    (dateSelect)="onDateToSelection($event)"
                    #f="ngbDatepicker"
                    id="dateInputTo"
                    [(ngModel)]="dpToDate"
                    readonly
                  >
                  <div class="input-group-append clear-date">
                    <span class="input-group-text b-radius-right" (click)="clearDateTo()"><i class="fa fa-times"></i> </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3 mb-md-0">
              <select class="form-control b-radius" (change)="changeVoucher()" [(ngModel)]="voucher">
                <option value="{{voucher.key}}" *ngFor="let voucher of vouchers">{{voucher.value}}</option>
              </select>
            </div>
            <div class="col-md-3 mb-1 mb-md-0 pl-md-0">
              <input type="text" class="form-control b-radius" placeholder="Search Name or Email" #searchNameOrEmail>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-2 teal">
        <div class="col-md-3">
          <div class="card mt-1 b-radius-125 p-3 p-md-0">
            <div class="card-body">
              <div class="fs-9em tablet-title">Total users who completed 7 day challenge</div>
              <h4 class="mt-1 card-text font-weight-bold">
                {{ users_completed }}
              </h4>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mt-1 b-radius-125 p-3 p-md-0">
            <div class="card-body">
              <div class="fs-9em tablet-title">Sleep Improvement</div>
              <h4 class="mt-1 card-text font-weight-bold">
                <span *ngIf="sleep_improvement > 0">+</span>{{ sleep_improvement }}%
              </h4>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mt-1 b-radius-125 p-3 p-md-0">
            <div class="card-body">
              <div class="fs-9em tablet-title">Calm Improvement</div>
              <h4 class="mt-1 card-text font-weight-bold">
                <span *ngIf="calm_improvement > 0">+</span>{{ calm_improvement }}%
              </h4>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-5">
          <div class="card mt-1 b-radius-125 p-3 p-md-0">
            <div class="card-body">
              <div class="fs-9em tablet-title">Energy Improvement</div>
              <h4 class="mt-1 card-text font-weight-bold">
                <span *ngIf="energy_improvement > 0">+</span>{{ energy_improvement }}%
              </h4>
            </div>
          </div>
        </div>
      </div>
   
  </div>

  <!-- Modal Loader -->
  <modal-loader [modalText]="modalText"></modal-loader>

</div>
